var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guest-layout"},[_c('div',{staticClass:"flex justify-center logo-wrapper"},[_c('logo',{staticClass:"logo--md"})],1),_c('router-view',{staticClass:"full-width"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }